import { useMemo } from 'react';
import { useMonteCarloQuery } from '../../../../../../api/useMonteCarloQuery';
import { AsyncComponentHookResult } from '../../../../../../../../Types/ComponentHookResult';
import { DataDTO } from '../../../../../../types/monteCarlo.types';
import { theme } from '../../../../../../../../theme/theme';

interface Chart {
  categories: string[];
  probabilityOfFailure: number;
  probabilityOfSuccess: number;
  series: DataDTO[];
}

export const useChart = (): AsyncComponentHookResult<Chart> => {
  const queryInfo = useMonteCarloQuery();

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const {
      ProbabilityOfSuccess: probabilityOfSuccess,
      Data: series,
      Categories: categories,
    } = queryInfo.data;

    const probabilityOfFailure = 1 - probabilityOfSuccess;

    return {
      probabilityOfSuccess,
      series: series.map(seriesData => ({
        ...seriesData,
        color: seriesData.color === '#5ABEE4' ? theme.colors.blue[500] : theme.colors.purple[500],
      })),
      categories,
      probabilityOfFailure,
    };
  }, [queryInfo.data]);

  return {
    ...queryInfo,
    data,
  };
};
